import * as React from "react"
import { Link } from "gatsby"
import * as styles from '../styles/Directory.module.scss'
import Header from "./Header"
const Directory = () =>
{
        return (
            <div className='directory'>
                <Header />
                <div className={styles.gender}>
                    <Link className={styles.women} to="/women">
                        <h3>Shop</h3>
                        <h1>Women</h1>
                    </Link>
                    <Link className={styles.men} to="/men">
                        <h3>Shop</h3>
                        <h1>Men</h1>
                    </Link>
                </div>
            </div>
            )
    }

export default Directory